// extracted by mini-css-extract-plugin
export default {"card":"EmailTemplateCard_card__PumhB","subject":"EmailTemplateCard_subject__fedJq","body":"EmailTemplateCard_body__I9frA"};